import React, { Component } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";
import {
  BusinessTrainingData,
  BusinessTestimonials,
  BusinessFAQ,
} from "../../Data/CommunityCoursesData";
import "./BusinessTraining.css";

/* ── Inline SVG Icons ── */
const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
  </svg>
);

const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m6 9 6 6 6-6"/>
  </svg>
);

const CheckCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);

const Clock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);

const Users = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const Globe = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

const Shield = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

const HeadSet = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>
  </svg>
);

const Calendar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const HealthcareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
  </svg>
);

const ChildcareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
  </svg>
);

const AdminIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
  </svg>
);

const CateringIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/>
    <line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/>
  </svg>
);

const Download = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

const Mail = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const Phone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.48 2 2 0 0 1 3.59 1.27h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.5a16 16 0 0 0 6.59 6.59l.91-.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const getPackageIcon = (id) => {
  switch (id) {
    case "healthcare-package": return <HealthcareIcon />;
    case "childcare-package": return <ChildcareIcon />;
    case "admin-package": return <AdminIcon />;
    case "catering-package": return <CateringIcon />;
    default: return <Shield />;
  }
};

const WHY_CARDS = [
  {
    icon: <Calendar />,
    title: "Flexible Delivery",
    desc: "On-site, blended, or fully remote — we work around your team's schedule to minimise disruption.",
  },
  {
    icon: <Globe />,
    title: "Multilingual Trainers",
    desc: "Our trainers can deliver in multiple languages, removing barriers for diverse workforces.",
  },
  {
    icon: <Shield />,
    title: "Compliance Experts",
    desc: "We know the regulatory landscape — CQC, Ofsted, food standards — so you don't have to.",
  },
  {
    icon: <HeadSet />,
    title: "Ongoing Support",
    desc: "A dedicated account manager guides you from booking through certification and beyond.",
  },
  {
    icon: <Users />,
    title: "Group Discounts",
    desc: "The more staff you train, the better the value. We tailor pricing to your team size.",
  },
  {
    icon: <CheckCircle />,
    title: "Funding Assistance",
    desc: "We help eligible organisations access funding to reduce or eliminate training costs.",
  },
];

const PROCESS_STEPS = [
  {
    number: "01",
    title: "Free Consultation",
    desc: "We start with a no-obligation call to understand your organisation, sector, and training goals.",
  },
  {
    number: "02",
    title: "Needs Assessment",
    desc: "We assess your team's current skills levels and identify the exact training requirements.",
  },
  {
    number: "03",
    title: "Custom Package",
    desc: "We design a bespoke programme with the right units, timeline, and delivery format for you.",
  },
  {
    number: "04",
    title: "Flexible Delivery",
    desc: "Training is delivered on-site or remotely — on your schedule, at your pace.",
  },
  {
    number: "05",
    title: "Certification",
    desc: "Staff graduate with nationally recognised, accredited qualifications and ongoing support.",
  },
];

class BusinessTraining extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openFaqIndex: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  toggleFaq = (index) => {
    this.setState((prev) => ({
      openFaqIndex: prev.openFaqIndex === index ? null : index,
    }));
  };

  render() {
    const { openFaqIndex } = this.state;

    return (
      <div className="business-training-page">
        <Navbar />

        {/* ── HERO ── */}
        <section className="bt-hero">
          <div className="bt-hero__bg" aria-hidden="true">
            <div className="bt-hero__pattern" />
            <div className="bt-hero__glow bt-hero__glow--1" />
            <div className="bt-hero__glow bt-hero__glow--2" />
          </div>

          <div className="bt-hero__content">
            <Link to="/training" className="bt-hero__back">← Back to Training Hub</Link>
            <span className="bt-hero__eyebrow">For Organisations · East London</span>

            <h1 className="bt-hero__title">
              Train Your Team.<br />
              <span className="bt-hero__title-accent">Transform Your Organisation.</span>
            </h1>

            <p className="bt-hero__subtitle">
              Bespoke, accredited training packages for healthcare, childcare, admin, and catering.
              Flexible delivery. Compliance guaranteed. Funding available.
            </p>

            <div className="bt-hero__ctas">
              <Link to="/contact" className="bt-btn bt-btn--primary">
                Book a Free Consultation <ArrowRight />
              </Link>
              <a
                href="/brochures/apt-business-training.pdf"
                download
                className="bt-btn bt-btn--secondary"
              >
                <Download /> Download Brochure
              </a>
            </div>
          </div>

          <div className="bt-hero__statsbar">
            <div className="bt-hero__stat">
              <span className="bt-hero__stat-n">50+</span>
              <span className="bt-hero__stat-l">Orgs Trained</span>
            </div>
            <div className="bt-hero__stat-divider" aria-hidden="true" />
            <div className="bt-hero__stat">
              <span className="bt-hero__stat-n">100%</span>
              <span className="bt-hero__stat-l">Compliance Rate</span>
            </div>
            <div className="bt-hero__stat-divider" aria-hidden="true" />
            <div className="bt-hero__stat">
              <span className="bt-hero__stat-n">4</span>
              <span className="bt-hero__stat-l">Sectors Covered</span>
            </div>
            <div className="bt-hero__stat-divider" aria-hidden="true" />
            <div className="bt-hero__stat">
              <span className="bt-hero__stat-n">On-Site</span>
              <span className="bt-hero__stat-l">Delivery Available</span>
            </div>
          </div>
        </section>

        {/* ── TRUST STRIP ── */}
        <div className="bt-trust-strip">
          <div className="bt-trust-strip__inner">
            {[
              "Fully Accredited Certifications",
              "On-Site or Remote Delivery",
              "Funding Assistance Available",
              "Dedicated Account Manager"
            ].map((item) => (
              <div key={item} className="bt-trust-strip__item">
                <CheckCircle /> {item}
              </div>
            ))}
          </div>
        </div>

        {/* ── INDUSTRY PACKAGES ── */}
        <section className="bt-packages">
          <div className="bt-packages__inner">
            <div className="bt-packages__header">
              <span className="bt-eyebrow">Industry Packages</span>
              <h2 className="bt-section-title">
                Sector-Specific Training That Works
              </h2>
              <p className="bt-section-sub">
                Each package is built around the precise compliance, skills, and accreditation
                requirements of your industry — not a generic one-size-fits-all solution.
              </p>
            </div>

            <div className="bt-packages__grid">
               {BusinessTrainingData.map((pkg) => {
                 const hasFullDetails = true; // Business packages always have details via CoursePage
                return (
                  <article key={pkg.id} className="bt-package-card">
                    <div className="bt-package-card__header">
                      <div className="bt-package-card__icon">
                        {getPackageIcon(pkg.id)}
                      </div>
                      <div className="bt-package-card__title-group">
                        <h3 className="bt-package-card__title">{pkg.title}</h3>
                        <p className="bt-package-card__subtitle">{pkg.shortDescription}</p>
                      </div>
                    </div>

                    <div className="bt-package-card__body">
                      <p className="bt-package-card__desc">{pkg.description}</p>

                      {pkg.outcomes && (
                        <div className="bt-package-card__outcomes">
                          <p className="bt-package-card__outcomes-title">Key Outcomes</p>
                          <ul className="bt-package-card__outcomes-list">
                            {pkg.outcomes.map((o, i) => (
                              <li key={i}><CheckCircle /> {o}</li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {pkg.features && (
                        <div className="bt-package-card__features">
                          <p className="bt-package-card__features-title">Package Includes</p>
                          <ul className="bt-package-card__features-list">
                            {pkg.features.map((f, i) => (
                              <li key={i}>{f}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    <div className="bt-package-card__footer">
                      <div className="bt-package-card__meta">
                        {pkg.duration && (
                          <span className="bt-package-card__meta-item">
                            <Clock /> {pkg.duration}
                          </span>
                        )}
                        {pkg.minGroupSize && (
                          <span className="bt-package-card__meta-item">
                            <Users /> Min. {pkg.minGroupSize} staff
                          </span>
                        )}
                      </div>
                      {hasFullDetails ? (
                        <Link
                          to={`/training/business/${pkg.id}`}
                          className="bt-package-card__cta"
                        >
                          View Full Details <ArrowRight />
                        </Link>
                      ) : (
                        <span className="bt-package-card__cta bt-package-card__cta--inactive">
                          Coming soon
                        </span>
                      )}
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── WHY CHOOSE APT ── */}
        <section className="bt-why">
          <div className="bt-why__inner">
            <div className="bt-why__header">
              <span className="bt-eyebrow">Why Organisations Choose APT</span>
              <h2 className="bt-section-title">More Than Just Training</h2>
              <p className="bt-section-sub">
                We're a community interest company, not a faceless training provider. We care
                deeply about outcomes for your staff and your organisation.
              </p>
            </div>
            <div className="bt-why__grid">
              {WHY_CARDS.map((card) => (
                <div key={card.title} className="bt-why__card">
                  <div className="bt-why__icon">{card.icon}</div>
                  <h3 className="bt-why__title">{card.title}</h3>
                  <p className="bt-why__desc">{card.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── PROCESS ── */}
        <section className="bt-process">
          <div className="bt-process__inner">
            <div className="bt-process__header">
              <span className="bt-eyebrow">How It Works</span>
              <h2 className="bt-section-title">From Enquiry to Certification</h2>
              <p className="bt-section-sub">
                A simple, guided process that gets your team trained and certified with
                minimal disruption to your operations.
              </p>
            </div>
            <div className="bt-process__steps">
              {PROCESS_STEPS.map((step) => (
                <div key={step.number} className="bt-process__step">
                  <div className="bt-process__step-number">{step.number}</div>
                  <h4 className="bt-process__step-title">{step.title}</h4>
                  <p className="bt-process__step-desc">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── CUSTOM TRAINING BANNER ── */}
        <div className="bt-custom-banner">
          <div className="bt-custom-banner__inner">
            <div className="bt-custom-banner__content">
              <span className="bt-eyebrow bt-eyebrow--white">Custom Solutions</span>
              <h2 className="bt-custom-banner__title">
                Need Something Bespoke?
              </h2>
              <p className="bt-custom-banner__desc">
                No two organisations are the same. We design fully custom training
                programmes — from single upskilling courses to comprehensive workforce
                development plans — tailored to your exact requirements and budget.
              </p>
            </div>
            <div className="bt-custom-banner__cta">
              <Link to="/contact" className="bt-btn bt-btn--white">
                Get a Custom Quote <ArrowRight />
              </Link>
            </div>
          </div>
        </div>

        {/* ── TESTIMONIALS ── */}
        <section className="bt-testimonials">
          <div className="bt-testimonials__inner">
            <div className="bt-testimonials__header">
              <span className="bt-eyebrow">What Organisations Say</span>
              <h2 className="bt-section-title">Trusted by Teams Across East London</h2>
            </div>
            <div className="bt-testimonials__grid">
              {BusinessTestimonials.map((t) => (
                <div key={t.id} className="bt-testimonial">
                  <blockquote className="bt-testimonial__quote">
                    "{t.quote}"
                  </blockquote>
                  <div className="bt-testimonial__author">
                    <div className="bt-testimonial__avatar">
                      {t.author.charAt(0)}
                    </div>
                    <div className="bt-testimonial__details">
                      <span className="bt-testimonial__name">{t.author}</span>
                      <span className="bt-testimonial__role">{t.role}</span>
                      <span className="bt-testimonial__org">{t.organisation}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── PARTNER LOGOS PLACEHOLDER ── */}
        <div className="bt-partner-logos">
          <div className="bt-partner-logos__inner">
            <p className="bt-partner-logos__label">
              Organisations we have trained
            </p>
            <div className="bt-partner-logos__grid">
              {["Healthcare Provider", "East London Nursery", "Catering Company", "Community Charity", "Care Home Group"].map((name) => (
                <div key={name} className="bt-partner-logo-placeholder">
                  {name}
                </div>
              ))}
            </div>
            <p className="bt-partner-logos__note">
              Partner logos coming soon — <Link to="/contact">get in touch</Link> to be featured.
            </p>
          </div>
        </div>

        {/* ── FAQ ── */}
        <section className="bt-faq">
          <div className="bt-faq__inner">
            <div className="bt-faq__header">
              <span className="bt-eyebrow">FAQs</span>
              <h2 className="bt-section-title">Common Questions</h2>
              <p className="bt-section-sub">
                Everything you need to know before booking your organisation's
                training.
              </p>
            </div>
            <div className="bt-faq__list">
              {BusinessFAQ.map((item, i) => (
                <div
                  key={i}
                  className={`bt-faq__item${openFaqIndex === i ? " bt-faq__item--open" : ""}`}
                >
                  <button
                    className="bt-faq__question"
                    onClick={() => this.toggleFaq(i)}
                    aria-expanded={openFaqIndex === i}
                  >
                    {item.question}
                    <ChevronDown className="bt-faq__icon" />
                  </button>
                  <div className="bt-faq__answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── FINAL CTA ── */}
        <section className="bt-final-cta">
          <div className="bt-final-cta__inner">
            <h2 className="bt-final-cta__title">Ready to Upskill Your Team?</h2>
            <p className="bt-final-cta__desc">
              Let's discuss your training needs and build a programme that works for
              your organisation, your budget, and your timeline.
            </p>
            <div className="bt-final-cta__btns">
              <Link to="/contact" className="bt-btn bt-btn--white">
                Book Free Consultation <ArrowRight />
              </Link>
              <a
                href="/brochures/apt-business-training.pdf"
                download
                className="bt-btn bt-btn--secondary"
              >
                <Download /> Download Brochure
              </a>
            </div>
            <div className="bt-final-cta__contact">
              <div className="bt-final-cta__contact-item">
                <Mail />
                <a href="mailto:info@alisarprospectstraining.org">
                  info@alisarprospectstraining.org
                </a>
              </div>
              <div className="bt-final-cta__contact-item">
                <Phone />
                <a href="tel:+442081234567">020 8123 4567</a>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default BusinessTraining;
